// extracted by mini-css-extract-plugin
export var image = "ImageCell-module--image--oof6S";
export var imageCell = "ImageCell-module--image-cell--ofEuo";